



















import { defineComponent, type PropType } from "vue-demi";
import GGGroup from "./GGGroup/GGGroup.vue";
import GGRowSlider from "../grid-generation/GGRowSlider/GGRowSlider.vue";
import GGNewsCard from "./GGNewsCard.vue";
import factoids from "../factoid";
import getValueForProp from "../../helper/getValueForProp";
import type { PageData } from "@constructor/shared-entity/type";

export default defineComponent({
  name: "GGSaleSection",
  components: {
    GGGroup,
    GGRowSlider,
    GGNewsCard,
    ...factoids,
  },
  props: {
    data: {
      type: Object as PropType<PageData>,
      required: true,
    },
  },
  computed: {
    list() {
      const value = getValueForProp(
        "filterSalesByIds",
        this.data.template.prop
      );
      const list = this.data.dataSource.data.sale || [];
      if (value) {
        const ids = value.split(",").map((id) => id);
        return list.filter((el) => ids.some((id) => id === el.id));
      }

      return list;
    },
  },
});
